(() => {
  'use strict';

  const tag = 'lavinde-loved-slider-v2';
  if (customElements.get(tag)) return;

  class LavindeLovedSliderV2 extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.track = this.querySelector('[data-loved-track]');
      this.viewport = this.querySelector('[data-loved-viewport]');
      if (!this.track) return;

      this.injectStyles();
      this.ensureMobileControls();

      this.prevButtons = Array.from(this.querySelectorAll('[data-loved-prev]'));
      this.nextButtons = Array.from(this.querySelectorAll('[data-loved-next]'));

      this.prevButtons.forEach((button) => button.addEventListener('click', () => this.slide(-1)));
      this.nextButtons.forEach((button) => button.addEventListener('click', () => this.slide(1)));

      this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
      window.addEventListener('resize', () => {
        this.renderDots();
        this.requestUpdate();
      }, { passive: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.renderDots();
          this.requestUpdate();
        });
        this.resizeObserver.observe(this.track);
      }

      setTimeout(() => {
        this.renderDots();
        this.requestUpdate();
      }, 120);

      this.requestUpdate();
    }

    injectStyles() {
      if (document.getElementById('LavindeLovedSliderV2Indicators')) return;

      const style = document.createElement('style');
      style.id = 'LavindeLovedSliderV2Indicators';
      style.textContent = `
        .lavinde-loved-slider-v2__mobile-controls {
          display: none;
        }

        .lavinde-loved-slider-v2__mobile-controls[hidden],
        .lavinde-loved-slider-v2__mobile-arrow[hidden] {
          display: none !important;
        }

        @media screen and (max-width: 749px) {
          .lavinde-loved-slider-v2__mobile-controls {
            display: flex;
            min-height: 26px;
            margin: -2px 0 0;
            align-items: center;
            justify-content: center;
            gap: 10px;
          }

          .lavinde-loved-slider-v2__mobile-arrow {
            display: inline-grid;
            width: 25px;
            height: 25px;
            padding: 0;
            place-items: center;
            border: 1px solid var(--lhpc-border);
            border-radius: 999px;
            background: #ffffff;
            color: var(--lhpc-text);
            box-shadow: 0 5px 15px rgba(17, 17, 17, 0.06);
            cursor: pointer;
            appearance: none;
          }

          .lavinde-loved-slider-v2__mobile-arrow span {
            display: block;
            margin-top: -2px;
            font-size: 22px;
            font-weight: 200;
            line-height: 1;
          }

          .lavinde-loved-slider-v2__mobile-arrow:disabled {
            cursor: default;
            opacity: 0.28;
          }

          .lavinde-loved-slider-v2__dots {
            display: flex;
            min-width: 48px;
            align-items: center;
            justify-content: center;
            gap: 6px;
          }

          .lavinde-loved-slider-v2__dot {
            display: block;
            width: 6px;
            height: 6px;
            min-width: 6px;
            min-height: 6px;
            padding: 0;
            border: 1px solid rgba(28, 28, 28, 0.34);
            border-radius: 999px;
            background: transparent;
            cursor: pointer;
            appearance: none;
            transition: width 180ms ease, background-color 180ms ease, border-color 180ms ease;
          }

          .lavinde-loved-slider-v2__dot[aria-current='true'] {
            width: 18px;
            border-color: var(--lhpc-text);
            background: var(--lhpc-text);
          }
        }

        @media screen and (min-width: 750px) {
          .lavinde-loved-slider-v2__mobile-controls {
            display: none !important;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .lavinde-loved-slider-v2__dot {
            transition: none;
          }
        }
      `;
      document.head.appendChild(style);
    }

    ensureMobileControls() {
      let controls = this.querySelector('[data-loved-mobile-controls]');

      if (!controls) {
        controls = document.createElement('div');
        controls.className = 'lavinde-loved-slider-v2__mobile-controls';
        controls.setAttribute('data-loved-mobile-controls', '');

        const prev = this.createMobileArrow('prev');
        const dots = document.createElement('div');
        dots.className = 'lavinde-loved-slider-v2__dots';
        dots.setAttribute('data-loved-dots', '');
        dots.setAttribute('aria-label', 'Produktnavigation');

        const next = this.createMobileArrow('next');

        controls.appendChild(prev);
        controls.appendChild(dots);
        controls.appendChild(next);

        const anchor = this.viewport || this.track;
        anchor.insertAdjacentElement('afterend', controls);
      }

      this.mobileControls = controls;
      this.dotsContainer = controls.querySelector('[data-loved-dots]');
      this.renderDots();
    }

    createMobileArrow(direction) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `lavinde-loved-slider-v2__mobile-arrow lavinde-loved-slider-v2__mobile-arrow--${direction}`;
      button.setAttribute(direction === 'prev' ? 'data-loved-prev' : 'data-loved-next', '');
      button.setAttribute('aria-label', direction === 'prev' ? 'Forrige produkt' : 'Næste produkt');

      const span = document.createElement('span');
      span.setAttribute('aria-hidden', 'true');
      span.textContent = direction === 'prev' ? '‹' : '›';
      button.appendChild(span);

      return button;
    }

    renderDots() {
      if (!this.dotsContainer) return;

      const slides = this.slides;
      if (this.dotCount === slides.length && this.dotsContainer.children.length === slides.length) return;

      this.dotCount = slides.length;
      this.dotsContainer.textContent = '';

      slides.forEach((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'lavinde-loved-slider-v2__dot';
        dot.setAttribute('data-loved-dot', String(index));
        dot.setAttribute('aria-label', `Gå til produkt ${index + 1}`);
        dot.addEventListener('click', () => this.scrollToIndex(index));
        this.dotsContainer.appendChild(dot);
      });
    }

    slide(direction) {
      const slides = this.slides;
      if (!slides.length) return;

      const current = this.activeIndex();
      const next = Math.max(0, Math.min(slides.length - 1, current + direction));
      this.scrollToIndex(next);
    }

    scrollToIndex(index) {
      const slide = this.slides[index];
      if (!slide) return;

      this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      this.requestUpdate();
    }

    activeIndex() {
      const slides = this.slides;
      if (!slides.length) return 0;

      const current = this.track.scrollLeft;
      let active = 0;
      let distance = Infinity;

      slides.forEach((slide, index) => {
        const diff = Math.abs(slide.offsetLeft - current);
        if (diff < distance) {
          distance = diff;
          active = index;
        }
      });

      return active;
    }

    requestUpdate() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    }

    update() {
      if (!this.track) return;

      const slides = this.slides;
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth - 2);
      const current = this.track.scrollLeft;
      const hasOverflow = max > 4 && slides.length > 1;
      const active = this.activeIndex();

      this.prevButtons.forEach((button) => {
        button.hidden = !hasOverflow;
        button.disabled = active <= 0 || current <= 2;
      });

      this.nextButtons.forEach((button) => {
        button.hidden = !hasOverflow;
        button.disabled = active >= slides.length - 1 || current >= max;
      });

      if (this.mobileControls) {
        this.mobileControls.hidden = !hasOverflow;
      }

      if (this.dotsContainer) {
        Array.from(this.dotsContainer.querySelectorAll('[data-loved-dot]')).forEach((dot, index) => {
          const selected = index === active;
          dot.setAttribute('aria-current', selected ? 'true' : 'false');
          dot.disabled = !hasOverflow || selected;
        });
      }
    }

    get slides() {
      return Array.from(this.track.querySelectorAll('[data-loved-slide]'));
    }
  }

  customElements.define(tag, LavindeLovedSliderV2);
})();
